// @flow

import { RECEIVE_ASSORTMENT, RECEIVE_FILTERED_ASSORTMENT } from '../constants';
import type { ReceiveAssortment, ReceiveFilteredAssortment } from '../actions';
import type { State } from '../types';

type AssortmentState = $PropertyType<State, 'filteredAssortment'>;

const initialState: AssortmentState = [];

const filteredAssortment = (
  state: AssortmentState = initialState,
  action: ReceiveFilteredAssortment | ReceiveAssortment,
): AssortmentState => {
  switch (action.type) {
    case RECEIVE_FILTERED_ASSORTMENT:
      return [...action.payload];
    case RECEIVE_ASSORTMENT:
      return action.payload;
    default:
      return state;
  }
};

export default filteredAssortment;
